import React from "react";
import { MetricCardData, MetricCardFactoryProps } from "../../type";
import { SimpleMetricCard } from "./SimpleMetricCard";
import { BreakdownCard } from "./BreakdownCard";
import { ChartCard } from "./ChartCard";
import { SplitValueCard } from "./SplitValueCard";
import { TimeBasedCard } from "./TimeBasedCard";
import { MultiMetricCard } from "./MultiMetricCard";
import { ValueComparisonCard } from "./ValueComparisonCard.tsx";

export const MetricCardFactory: React.FC<MetricCardFactoryProps> = ({
  data,
}) => {
  const cardType = data.cardType ?? inferCardType(data);

  switch (cardType) {
    case "breakdown":
      return <BreakdownCard data={data} />;
    case "chart":
      return <ChartCard data={data} />;
    case "split":
      return <SplitValueCard data={data} />;
    case "time-based":
      return <TimeBasedCard data={data} />;
    case "multi-metric":
      return <MultiMetricCard data={data} />;
    case "gauge":
      return <ValueComparisonCard data={data} />;
    case "simple":
    default:
      return <SimpleMetricCard data={data} />;
  }
};

const inferCardType = (data: MetricCardData): string => {
  if (data.breakdown && data.breakdown.length > 0) return "breakdown";
  if (data.chart) return "chart";
  if (data.splitValues && data.splitValues.length > 0) return "split";
  if (data.multiMetrics && data.multiMetrics.length > 0) return "multi-metric";
  if (data.timeframe && !data.comparison && !data.forecast) return "time-based";
  return "simple";
};
